import { useState } from 'react';
import { curriculumModules } from '@/mocks/programData';

const categoryColors: Record<string, string> = {
  Fundamentos: 'bg-emerald-50 text-emerald-700',
  Gestão: 'bg-amber-50 text-amber-700',
  Investigação: 'bg-sky-50 text-sky-700',
  Ética: 'bg-rose-50 text-rose-700',
  Tecnologia: 'bg-violet-50 text-violet-700',
  Contexto: 'bg-orange-50 text-orange-700',
};

export default function Curriculum() {
  const [activeSemester, setActiveSemester] = useState(0);

  return (
    <section id="curriculo" className="py-20 md:py-28 bg-white">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <span className="text-accent text-sm font-semibold uppercase tracking-wider">Estrutura Curricular</span>
            <h2 className="font-display text-3xl md:text-4xl font-bold text-primary mt-3">
              Módulos de Aprendizagem
            </h2>
            <p className="text-gray-600 mt-4 max-w-xl mx-auto">
              12 módulos temáticos no primeiro ano, seguidos de dissertação no segundo ano.
              Total de 120 ECTS.
            </p>
          </div>

          <div className="flex justify-center mb-10">
            <div className="inline-flex bg-warm-100 rounded-full p-1">
              {curriculumModules.map((sem, i) => (
                <button
                  key={sem.semester}
                  onClick={() => setActiveSemester(i)}
                  className={`px-6 py-2.5 rounded-full text-sm font-semibold transition-all whitespace-nowrap ${
                    activeSemester === i
                      ? 'bg-primary text-white'
                      : 'text-gray-600 hover:text-primary'
                  }`}
                >
                  {sem.semester}
                </button>
              ))}
            </div>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {curriculumModules[activeSemester].modules.map((mod) => (
              <div
                key={mod.code}
                className="border border-gray-200 rounded-2xl p-6 hover:border-accent/40 hover:shadow-md transition-all"
              >
                <div className="flex items-center justify-between mb-4">
                  <span className={`px-3 py-1 rounded-full text-xs font-semibold ${categoryColors[mod.category] || 'bg-gray-100 text-gray-700'}`}>
                    {mod.category}
                  </span>
                  <span className="w-10 h-10 rounded-full bg-primary flex items-center justify-center text-white text-sm font-bold">
                    {mod.code}
                  </span>
                </div>
                <h3 className="text-base font-bold text-primary mb-2 leading-snug">
                  {mod.name}
                </h3>
                <div className="flex items-center gap-4 text-sm text-gray-500 mb-4">
                  <span className="flex items-center gap-1">
                    <i className="ri-time-line" />
                    {mod.hours}h
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-star-line" />
                    {mod.credits} ECTS
                  </span>
                </div>
                <ul className="space-y-1.5">
                  {mod.topics.map((topic, j) => (
                    <li key={j} className="flex items-start gap-2 text-sm text-gray-600">
                      <i className="ri-check-line text-accent text-xs mt-1 flex-shrink-0" />
                      {topic}
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-10 bg-primary/5 rounded-2xl p-6 md:p-8 flex flex-col md:flex-row items-center gap-6">
            <div className="w-14 h-14 rounded-xl bg-primary flex items-center justify-center flex-shrink-0">
              <i className="ri-file-paper-2-line text-white text-2xl" />
            </div>
            <div className="flex-1 text-center md:text-left">
              <h4 className="text-lg font-bold text-primary mb-1">Dissertação de Mestrado</h4>
              <p className="text-gray-600 text-sm">
                Segundo ano dedicado à elaboração e defesa pública da dissertação sob orientação.
                Seminários de apoio, desenvolvimento da investigação e provas públicas.
              </p>
            </div>
            <div className="flex items-center gap-4 text-sm text-gray-600 flex-shrink-0">
              <span className="flex items-center gap-1">
                <i className="ri-time-line" />
                12 meses
              </span>
              <span className="flex items-center gap-1">
                <i className="ri-star-line" />
                60 ECTS
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}